import { render, staticRenderFns } from "./MoshaverKpi.vue?vue&type=template&id=4598977a&scoped=true&"
import script from "./MoshaverKpi.vue?vue&type=script&lang=js&"
export * from "./MoshaverKpi.vue?vue&type=script&lang=js&"
import style0 from "./MoshaverKpi.vue?vue&type=style&index=0&id=4598977a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598977a",
  null
  
)

export default component.exports